<template>
  <div>
    <loginHeader class="header"></loginHeader>
    <loginFooter></loginFooter>
    <div class="login_outer">
      <div class="login_wrap">
        <div class="left-bg">
          <div class="ddbes-logo"></div>
          <div class="ddbes-slogan">每一份工作&nbsp;都要有担当</div>
        </div>
        <div class="right-login">
          <div class="tab_wrap" id="switchTab">
            <div
              @click="qr_tab"
              id="qr_title"
              class="tab"
              data-type="_qrTab_"
              data-tab="_accountTab_"
            >扫码登录</div>
            <div class="tab_divider"></div>
            <div
              @click="account_tab"
              class="tab active"
              data-type="_accountTab_"
              data-tab="_qrTab_"
              id="account_title"
            >验证码登录</div>
          </div>
          <!-- 账号登录 -->
          <div class="account-login" id="_accountTab_">
            <div class="form_wrap">
              <el-input
                class="input"
                id="phone_num"
                maxlength="11"
                placeholder="请输入手机号码"
                prefix-icon="el-icon-user"
                v-model="phone_number"
                clearable
                @blur="verification_mobile"
              ></el-input>
              <el-input
                class="input"
                id="_password_"
                maxlength="6"
                placeholder="请输入验证码"
                prefix-icon="el-icon-lock"
                v-model="verification_code"
              ></el-input>
              <div @click="getVerifcation" class="get-code" id="_countdown_">获取验证码</div>
            </div>
            <div class="error-text" id="_error_"></div>
            <div class="login_type">
              <div class="verification_login">
                <a @click.prevent="login" href>账号登录</a>
              </div>
              <div class="forget-pwd">
                <a @click.prevent="retrieve" href>找回密码</a>
              </div>
            </div>
            <div class="btn-style" id="login_button" @click="handleClickLogin">登录</div>
          </div>
          <!-- 扫码登录 -->
          <div class="qr-login" id="_qrTab_">
            <div class="qr_wrap"></div>
            <div class="refresh-qr">
              <i class="refresh-icon"></i>
              <span>刷新</span>
            </div>
            <div class="refresh-title">请使用 担当APP 或 微信 扫码登录</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { validateTel, validatePwd } from "@/utils/validate";
import { showError, addErrorClass, emitEvent } from "@/utils/common";
import { countdown } from "@/utils";
import { version } from "punycode";
import { verificationApi } from "@/api/index";
// import('@/js/countdown.js')
export default {
  components: {
    loginHeader: () =>
      import(/* webpackChunkName: "design" */ "../components/login_header"),
    loginFooter: () =>
      import(/* webpackChunkName: "design" */ "../components/login_footer")
  },
  data() {
    return {
      phone_number: "",
      verification_code: "",
      version: 1
    };
  },
  mounted() {
    this.passwordEnter();
  },
  methods: {
    qr_tab() {
      $("#_accountTab_").hide();
      $("#_qrTab_").show();
      $("#qr_title").css("color", "#2479ED");
      $("#account_title").css("color", "#999999");
    },
    account_tab() {
      $("#_accountTab_").show();
      $("#_qrTab_").hide();
      $("#account_title").css("color", "#2479ED");
      $("#qr_title").css("color", "#999999");
    },
    retrieve() {
      this.$router.push({
        path: `/retrieve`
      });
    },
    login() {
      this.$router.push({
        path: `/`
      });
    },
    verification_mobile() {
      const mobile = this.phone_number;
      if (!validateTel(mobile)) {
        showError("手机号码格式不正确");
        addErrorClass("_input_");
        addErrorClass("_error_", !0);
      } else {
        showError("");
        addErrorClass("_password_");
        addErrorClass("phone_num", !0);
      }
    },
    getVerifcation() {
      const mobile = this.phone_number;
      if (!validateTel(mobile)) {
        showError("手机号码格式不正确");
        addErrorClass("_input_");
        addErrorClass("_error_", !0);
      } else {
        this.countStart();
      }
    },
    countStart() {
      var time = 60;
      // console.log(this);
      // let _this = this;
      // const mobile = this.phone_number;
      // const verification = this.verification_code;
      settime($("#_countdown_"));
      function settime(obj) {
        if (time == 0) {
          $("#_countdown_").attr("disabled", false);
          $("#_countdown_").html("获取验证码");
          $("#_countdown_").removeClass("notclick");
          time = 60;
          return;
        } else {
          $("#_countdown_").html(time + "s");
          time--;
          $("#_countdown_").addClass("notclick");
          console.log(this, "165");

          // let data = {
          //   mobile1: _this.phone_number,
          //   password1: _this.verification_code,
          //   version: _this.version
          // };
          // console.log(data)
          // verificationApi(data)
          //   .then(res => {
          //     setGstore("loginData", res.data);
          //     this.$router.push({
          //       path: `/firstpage`
          //     });
          //   })
          //   .catch(error => {});
        }
        setTimeout(function() {
          settime(obj);
        }, 1000);
      }
    },
    handleClickLogin() {
      const mobile = this.phone_number;
      const verification = this.verification_code;
      let _this = this;
      if (!validateTel(mobile)) {
        showError("手机号码格式不正确");
        addErrorClass("_input_");
        addErrorClass("_error_", !0);
      } else if (verification != "") {
        $("#login_button").text("登录中...");
        $("#login_button").addClass("notclick");
        // this.$router.push({
        //   path: `/firstpage`
        // });
        let data = {
          mobile1: _this.phone_number,
          password1: _this.verification_code,
          version: _this.version
        };
        verificationApi(data)
          .then(res => {
            setGstore("loginData", res.data);
            this.$router.push({
              path: `/firstpage`
            });
          })
          .catch(error => {});
      }
    },
    passwordEnter() {
      $("#verification").on("keyup", event => {
        if (event.keyCode === 13) {
          this.handleClickLogin();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.notclick {
  pointer-events: none;
}

.login_outer {
  position: absolute;
  top: 60px;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login_wrap {
  width: 870px;
  height: 520px;
  display: flex;
  overflow: auto;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 8px 16px 0px rgba(36, 121, 237, 0.1);
}

.left-bg {
  width: 470px;
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: url('../assets/login_bg.png') no-repeat center / 100%;

  .ddbes-logo {
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
    background: url('../assets/logo-fff@2x.png') no-repeat center / 100%;
  }

  .ddbes-slogan {
    color: #fff;
    font-size: 18px;
  }
}

.right-login {
  flex: 1;
  padding: 48px 40px 0;
}

.tab_wrap {
  display: flex;
  position: relative;
  justify-content: center;
  justify-content: space-between;
  padding: 0 84 - 40px;

  .tab {
    color: #999;
    font-size: 18px;
    cursor: pointer;
    transition: color 0.3s;

    &:hover, &.active {
      color: #2479ED;
    }
  }

  .tab_divider {
    width: 1px;
    height: 16px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background-color: #BDC1C9;
  }
}

.account-login, .qr-login {
  margin-top: 55px;
}

.form_wrap {
  position: relative;

  .input {
    height: 48px;

    &:first-child {
      margin-bottom: 20px;
    }
  }

  .get-code {
    // width: 60px;
    padding-left: 10px;
    position: absolute;
    top: 80px;
    left: 240px;
    font-size: 12px;
    color: #2479ED;
    border-left: 1px solid #999999;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.error-text {
  color: #FF0000;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  text-align: center;
}

.login_type {
  display: flex;
}

.verification_login {
  text-align: left;
  margin-bottom: 20px;
  flex: 1;

  >a {
    color: #323232;
    font-size: 14px;
    transition: color 0.3s;
    text-decoration: none;

    &:hover {
      color: #2479ED;
    }
  }
}

.forget-pwd {
  text-align: right;
  margin-bottom: 20px;

  >a {
    color: #323232;
    font-size: 14px;
    transition: color 0.3s;
    text-decoration: none;

    &:hover {
      color: #2479ED;
    }
  }
}

.btn-style {
  color: #ffffff;
  font-size: 16px;
  width: 100%;
  height: 40px;
  margin-bottom: 20px;
  text-align: center;
  line-height: 40px;
  border-radius: 4px;
  transition: background-color 0.3s;
  background-color: lighten(#2479ED, 10%);

  &:hover {
    cursor: pointer;
    background-color: #2479ed;
  }
}

.qr-login {
  display: none;

  .qr_wrap {
    width: 200px;
    height: 200px;
    padding: 18px;
    margin: auto;
    border-radius: 4px;
    border: 1px solid #BDC1C9;
  }

  .refresh-qr {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 13px auto 25px;

    >span {
      color: #999;
      font-size: 14px;
    }

    .refresh-icon {
      width: 18px;
      height: 18px;
      margin-right: 6px;
      background: url('../assets/refresh@2x.png') no-repeat center / 100%;
    }
  }

  .refresh-title {
    color: #323232;
    font-size: 14px;
    text-align: center;
    margin-top: 25px;
  }
}
</style>
